import React from 'react'
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components'
import { ThemeProvider as MuiThemeProvider } from '@mui/material'

import { defaultTheme } from '../../defaultTheme'
import muiTheme from './muiTheme'

export const FeedbotThemeProvider: React.FC = ({ children }) => (
  <MuiThemeProvider theme={muiTheme}>
    <StyledComponentsThemeProvider theme={defaultTheme()}>{children}</StyledComponentsThemeProvider>
  </MuiThemeProvider>
)
